import React from 'react';
import { Form } from 'react-bootstrap';

interface FormPhoneProps {
  phone: string | null;
  setPhone: (phone: string | null) => void;
}

function FormPhone({ phone, setPhone }: FormPhoneProps) {
  return (
    <Form.Group className="mb-3" controlId="formPhone">
      <Form.Label>Numer telefonu:</Form.Label>
      <Form.Control type="telephone" placeholder="np. +48 123 456 789" value={phone || ''} onChange={(event: any) => {
        setPhone(event.target.value || null);
      }} />
    </Form.Group>
  );
}

export default FormPhone;
